import { takeLatest, put, call } from 'redux-saga/effects';

import { listPragaDoenca } from '../service';
import {
  NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA,
  NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_PENDING,
  NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_SUCCESS,
  NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_FAILURE,
} from '../actionTypes';
import { CONST_FILTER_PRAGA_DOENCA } from '@commons/consts';

function* sagaNewFilterNextPagePragaDoenca(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_PENDING });

  try {
    let filterSaved = sessionStorage.getItem(CONST_FILTER_PRAGA_DOENCA) !== null
      ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PRAGA_DOENCA))
      : null;

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    // Buscar registros
    const queryString = `?size=${newFilter.rows}&page=${newFilter.page}${newFilter.where}`;
    const list = yield call(listPragaDoenca, queryString);

    sessionStorage.setItem(CONST_FILTER_PRAGA_DOENCA, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_SUCCESS,
      list: list,
      filter: newFilter
    });
  } catch (error) {
    yield put({ type: NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_FAILURE });
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterNextPagePragaDoenca() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA, sagaNewFilterNextPagePragaDoenca);
}